// The one currency format for the storefront (#28 §3): "Rs. 1,234.56".
// en-IN grouping — Nepal uses the lakh/crore numbering system. Previously five
// different spellings were in use (रु., Rs., NPR, ₨, ₹).
export const formatNPR = (value) => {
	const n = Number(value);
	return `Rs. ${(Number.isFinite(n) ? n : 0).toLocaleString('en-IN', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`;
};

/** Range display for price spans: "Rs. 10.00 – Rs. 20.00". */
export const formatNPRRange = (low, high) =>
	`${formatNPR(low)} – ${formatNPR(high)}`;
